// import React from 'react';
// import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import InstallPrompt from './components/common/InstallPrompt';
// import { Toaster } from 'react-hot-toast';
// import { AuthProvider, useAuth }           from './context/AuthContext';
// import { NotificationProvider }            from './context/NotificationContext';
// import { ThemeProvider }                   from './context/ThemeContext';
// import { ModuleProvider }                  from './context/ModuleContext';

// // Nursery module pages
// import NurseryHomePage          from './modules/nursery/pages/NurseryHomePage';
// import NurseryListPage          from './modules/nursery/pages/NurseryListPage';
// import NurseryDetailPage        from './modules/nursery/pages/NurseryDetailPage';
// import NurseryCatalogPage       from './modules/nursery/pages/NurseryCatalogPage';
// import NurseryProductDetailPage from './modules/nursery/pages/NurseryProductDetailPage';
// import NurseryCartPage          from './modules/nursery/pages/NurseryCartPage';
// import NurseryOrdersPage        from './modules/nursery/pages/NurseryOrdersPage';
// import BottomNav                from './components/layout/BottomNav';
// import NearbyNurseryPage from "./modules/nursery/pages/NearbyNurseriesPage";

// // Land module pages
// import LandHomePage         from './modules/land/pages/LandHomePage';
// import LandListingsPage     from './modules/land/pages/LandListingsPage';
// import LandMyListingsPage   from './modules/land/pages/LandMyListingsPage';
// import LandAddPropertyPage  from './modules/land/pages/LandAddPropertyPage';
// import LandMessagesPage     from './modules/land/pages/LandMessagesPage';

// // Auth
// import LoginPage            from './pages/auth/LoginPage';
// import SelectRolePage       from './pages/auth/SelectRolePage';
// import CompleteProfilePage  from './pages/auth/CompleteProfilePage';
// // Main
// import DashboardPage        from './pages/dashboard/DashboardPage';
//  import BuyerDashboardPage from './pages/dashboard/BuyerDashboardPage';

// import MyCropsPage          from './pages/crops/MyCropsPage';
// import AddCropPage          from './pages/crops/AddCropPage';
// import CropDetailPage       from './pages/crops/CropDetailPage';
// import AddStagePage         from './pages/crops/AddStagePage';
// import MarketplacePage      from './pages/marketplace/MarketplacePage';
// // Profile & Social
// import ProfilePage          from './pages/profile/ProfilePage';
// import FarmerProfilePage    from './pages/profile/FarmerProfilePage';
// import FarmersPage          from './pages/profile/FarmersPage';
// // Search & Notifications
// import SearchPage           from './pages/SearchPage';
// import NotificationsPage    from './pages/NotificationsPage';
// // Support ← added
// import SupportPage          from './pages/support/SupportPage';
// // Requests
// import CreateRequestPage    from './pages/requests/CreateRequestPage';
// import MyRequestsPage       from './pages/requests/MyRequestsPage';
// import IncomingRequestsPage from './pages/requests/IncomingRequestsPage';
// import AgentDashboardPage   from './pages/requests/AgentDashboardPage';
// // Admin
// import AdminDashboard  from './pages/admin/AdminDashboard';
// import AdminCropPage   from './pages/admin/AdminCropPage';

// const NO_NAV = ['/login', '/select-role', '/complete-profile'];

// function ProtectedRoute({ children, adminOnly = false }) {
//   const { user, loading } = useAuth();
//   if (loading) return (
//     <div className="loading-page">
//       <span className="spinner spinner--lg" />
//       <span>Loading...</span>
//     </div>
//   );
//   if (!user) return <Navigate to="/login" replace />;
//   if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
//   return children;
// }

// function AppRoutes() {
//   const { pathname } = useLocation();
//   const showNav = !NO_NAV.some(p => pathname.startsWith(p));

//   return (
//     <>
//       <Routes>
//         <Route path="/login"            element={<LoginPage />} />
//         <Route path="/select-role"      element={<ProtectedRoute><SelectRolePage /></ProtectedRoute>} />
//         <Route path="/complete-profile" element={<ProtectedRoute><CompleteProfilePage /></ProtectedRoute>} />

//         <Route path="/"                 element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
//         <Route path="/marketplace"      element={<ProtectedRoute><MarketplacePage /></ProtectedRoute>} />
//         <Route path="/search"           element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
//         <Route path="/notifications"    element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
//         <Route path="/support"          element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
    
//         <Route path="/buyer" element={<ProtectedRoute><BuyerDashboardPage /></ProtectedRoute>} />
//         <Route path="/my-crops"         element={<ProtectedRoute><MyCropsPage /></ProtectedRoute>} />
//         <Route path="/add-crop"         element={<ProtectedRoute><AddCropPage /></ProtectedRoute>} />
//         <Route path="/crop/:id"         element={<CropDetailPage />} />
//         <Route path="/crop/:id/add-stage" element={<ProtectedRoute><AddStagePage /></ProtectedRoute>} />

//         <Route path="/profile"          element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
//         <Route path="/farmer/:id"       element={<FarmerProfilePage />} />
//         <Route path="/farmers"          element={<ProtectedRoute><FarmersPage /></ProtectedRoute>} />

//         <Route path="/requests/new"      element={<ProtectedRoute><CreateRequestPage /></ProtectedRoute>} />
//         <Route path="/requests/my"       element={<ProtectedRoute><MyRequestsPage /></ProtectedRoute>} />
//         <Route path="/requests/incoming" element={<ProtectedRoute><IncomingRequestsPage /></ProtectedRoute>} />
//         <Route path="/agent"             element={<ProtectedRoute><AgentDashboardPage /></ProtectedRoute>} />

//         <Route path="/nursery"           element={<ProtectedRoute><NurseryHomePage /></ProtectedRoute>} />
//         <Route path="/nursery/list"      element={<ProtectedRoute><NurseryListPage /></ProtectedRoute>} />
//         <Route path="/nursery/:id"       element={<ProtectedRoute><NurseryDetailPage /></ProtectedRoute>} />
//         <Route path="/nursery/nearby"    element={<ProtectedRoute><NearbyNurseryPage /></ProtectedRoute>} />

//         <Route path="/land"              element={<ProtectedRoute><LandHomePage /></ProtectedRoute>} />
//         <Route path="/land/listings"     element={<ProtectedRoute><LandListingsPage /></ProtectedRoute>} />
//         <Route path="/land/my-listings"  element={<ProtectedRoute><LandMyListingsPage /></ProtectedRoute>} />
//         <Route path="/land/add"          element={<ProtectedRoute><LandAddPropertyPage /></ProtectedRoute>} />
//         <Route path="/land/messages"     element={<ProtectedRoute><LandMessagesPage /></ProtectedRoute>} />

//         <Route path="/admin"             element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
//         <Route path="/admin/crops"       element={<ProtectedRoute adminOnly><AdminCropPage /></ProtectedRoute>} />
//         <Route path="*"                  element={<Navigate to="/" replace />} />
//       </Routes>
//       {showNav && <BottomNav />}
//     </>
//   );
// }

// export default function App() {
//   return (
//     <BrowserRouter>
//       <ThemeProvider>
//         <ModuleProvider>
//           <AuthProvider>
//             <NotificationProvider>
//               <AppRoutes />
//               <InstallPrompt />
//               <Toaster position="top-center" toastOptions={{ duration:2500, style:{ borderRadius:10, fontSize:14, maxWidth:340 } }} />
//             </NotificationProvider>
//           </AuthProvider>
//         </ModuleProvider>
//       </ThemeProvider>
//     </BrowserRouter>
//   );
// }

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import InstallPrompt from './components/common/InstallPrompt';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth }           from './context/AuthContext';
import { NotificationProvider }            from './context/NotificationContext';
import { ThemeProvider }                   from './context/ThemeContext';
import { ModuleProvider }                  from './context/ModuleContext';

// Nursery module pages
import NurseryHomePage          from './modules/nursery/pages/NurseryHomePage';
import NurseryListPage          from './modules/nursery/pages/NurseryListPage';
import NurseryDetailPage        from './modules/nursery/pages/NurseryDetailPage';
import NurseryCatalogPage       from './modules/nursery/pages/NurseryCatalogPage';
import NurseryProductDetailPage from './modules/nursery/pages/NurseryProductDetailPage';
import NurseryCartPage          from './modules/nursery/pages/NurseryCartPage';
import NurseryOrdersPage        from './modules/nursery/pages/NurseryOrdersPage';
import BottomNav                from './components/layout/BottomNav';
import NearbyNurseryPage from "./modules/nursery/pages/NearbyNurseriesPage";

// Land module pages
import LandHomePage         from './modules/land/pages/LandHomePage';
import LandListingsPage     from './modules/land/pages/LandListingsPage';
import LandMyListingsPage   from './modules/land/pages/LandMyListingsPage';
import LandAddPropertyPage  from './modules/land/pages/LandAddPropertyPage';
import LandMessagesPage     from './modules/land/pages/LandMessagesPage';
import LandDetailPage       from './modules/land/pages/LandDetailPage';

// Auth
import LoginPage            from './pages/auth/LoginPage';
import SelectRolePage       from './pages/auth/SelectRolePage';
import CompleteProfilePage  from './pages/auth/CompleteProfilePage';
// Main
import DashboardPage        from './pages/dashboard/DashboardPage';
 import BuyerDashboardPage from './pages/dashboard/BuyerDashboardPage';

import MyCropsPage          from './pages/crops/MyCropsPage';
import AddCropPage          from './pages/crops/AddCropPage';
import CropDetailPage       from './pages/crops/CropDetailPage';
import AddStagePage         from './pages/crops/AddStagePage';
import MarketplacePage      from './pages/marketplace/MarketplacePage';
// Profile & Social
import ProfilePage          from './pages/profile/ProfilePage';
import FarmerProfilePage    from './pages/profile/FarmerProfilePage';
import FarmersPage          from './pages/profile/FarmersPage';
// Search & Notifications
import SearchPage           from './pages/SearchPage';
import NotificationsPage    from './pages/NotificationsPage';
// Support ← added
import SupportPage          from './pages/support/SupportPage';
// Requests
import CreateRequestPage    from './pages/requests/CreateRequestPage';
import MyRequestsPage       from './pages/requests/MyRequestsPage';
import IncomingRequestsPage from './pages/requests/IncomingRequestsPage';
import AgentDashboardPage   from './pages/requests/AgentDashboardPage';
// Admin
import AdminDashboard  from './pages/admin/AdminDashboard';
import AdminCropPage   from './pages/admin/AdminCropPage';
import AdminLandPage   from './pages/admin/AdminLandPage';

const NO_NAV = ['/login', '/select-role', '/complete-profile', '/land/add'];

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="loading-page">
      <span className="spinner spinner--lg" />
      <span>Loading...</span>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

// A single land listing's detail page (e.g. /land/64f...) — has its own
// sticky "Contact Owner" bar, so the tab bar is hidden there. The known
// static /land/* sub-routes (add, listings, my-listings, messages) keep it.
const isLandDetailPage = (pathname) =>
  /^\/land\/(?!add$|listings$|my-listings$|messages$)[^/]+$/.test(pathname);

function AppRoutes() {
  const { pathname } = useLocation();
  const showNav = !NO_NAV.some(p => pathname.startsWith(p)) && !isLandDetailPage(pathname);

  return (
    <>
      <Routes>
        <Route path="/login"            element={<LoginPage />} />
        <Route path="/select-role"      element={<ProtectedRoute><SelectRolePage /></ProtectedRoute>} />
        <Route path="/complete-profile" element={<ProtectedRoute><CompleteProfilePage /></ProtectedRoute>} />

        <Route path="/"                 element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/marketplace"      element={<ProtectedRoute><MarketplacePage /></ProtectedRoute>} />
        <Route path="/search"           element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
        <Route path="/notifications"    element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path="/support"          element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
    
        <Route path="/buyer" element={<ProtectedRoute><BuyerDashboardPage /></ProtectedRoute>} />
        <Route path="/my-crops"         element={<ProtectedRoute><MyCropsPage /></ProtectedRoute>} />
        <Route path="/add-crop"         element={<ProtectedRoute><AddCropPage /></ProtectedRoute>} />
        <Route path="/crop/:id"         element={<CropDetailPage />} />
        <Route path="/crop/:id/add-stage" element={<ProtectedRoute><AddStagePage /></ProtectedRoute>} />

        <Route path="/profile"          element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/farmer/:id"       element={<FarmerProfilePage />} />
        <Route path="/farmers"          element={<ProtectedRoute><FarmersPage /></ProtectedRoute>} />

        <Route path="/requests/new"      element={<ProtectedRoute><CreateRequestPage /></ProtectedRoute>} />
        <Route path="/requests/my"       element={<ProtectedRoute><MyRequestsPage /></ProtectedRoute>} />
        <Route path="/requests/incoming" element={<ProtectedRoute><IncomingRequestsPage /></ProtectedRoute>} />
        <Route path="/agent"             element={<ProtectedRoute><AgentDashboardPage /></ProtectedRoute>} />

        <Route path="/nursery"           element={<ProtectedRoute><NurseryHomePage /></ProtectedRoute>} />
        <Route path="/nursery/list"      element={<ProtectedRoute><NurseryListPage /></ProtectedRoute>} />
        <Route path="/nursery/:id"       element={<ProtectedRoute><NurseryDetailPage /></ProtectedRoute>} />
        <Route path="/nursery/nearby"    element={<ProtectedRoute><NearbyNurseryPage /></ProtectedRoute>} />

        <Route path="/land"              element={<ProtectedRoute><LandHomePage /></ProtectedRoute>} />
        <Route path="/land/listings"     element={<ProtectedRoute><LandListingsPage /></ProtectedRoute>} />
        <Route path="/land/my-listings"  element={<ProtectedRoute><LandMyListingsPage /></ProtectedRoute>} />
        <Route path="/land/add"          element={<ProtectedRoute><LandAddPropertyPage /></ProtectedRoute>} />
        <Route path="/land/messages"     element={<ProtectedRoute><LandMessagesPage /></ProtectedRoute>} />
        <Route path="/land/:id"          element={<ProtectedRoute><LandDetailPage /></ProtectedRoute>} />

        <Route path="/admin"             element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/crops"       element={<ProtectedRoute adminOnly><AdminCropPage /></ProtectedRoute>} />
        <Route path="/admin/land"        element={<ProtectedRoute adminOnly><AdminLandPage /></ProtectedRoute>} />
        <Route path="*"                  element={<Navigate to="/" replace />} />
      </Routes>
      {showNav && <BottomNav />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ModuleProvider>
          <AuthProvider>
            <NotificationProvider>
              <AppRoutes />
              <InstallPrompt />
              <Toaster position="top-center" toastOptions={{ duration:2500, style:{ borderRadius:10, fontSize:14, maxWidth:340 } }} />
            </NotificationProvider>
          </AuthProvider>
        </ModuleProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}